import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { SimulationFailure, SimulationRequest, SimulationSuccess } from './actions';
import { HomeSimulation } from '@models/swagger';

export const featureKey = 'simulation';

export interface State {
  data: HomeSimulation[] | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: [],
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(SimulationFailure, (state, { error }) => ({ ...state, data: [], error, loading: false })),
    on(SimulationRequest, state => ({ ...state, error: null, loading: true })),
    on(SimulationSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
